import { Descriptions } from "@/components/v2";
import { Button, Card } from "@rumbledirect/ui";
import { Popconfirm, Space, type DescriptionsProps } from "antd";
import { Link } from "react-router-dom";
import { UseMutationResult } from "@tanstack/react-query";
import { ReplacementTransportPlan } from "@rumble-it/common-lib/types/models/ReplacementTransportPlan.interface";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

interface ReplacementTransportPlanDetailCardProps {
  replacementTransportPlan?: ReplacementTransportPlan;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const ReplacementTransportPlanDetailCard = ({
  replacementTransportPlan,
  isLoading,
  deleteMutation,
}: ReplacementTransportPlanDetailCardProps) => {
  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Vervangend vervoer plan"
      extra={
        <Space>
          <Link
            to={`/replacement-transport/plans/${replacementTransportPlan?.id}/edit`}
          >
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Vervangend vervoer plan verwijderen"
            description="Weet je zeker dat je deze vervangend vervoer plan wil verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      {(() => {
        const items: DescriptionsProps["items"] = [
          {
            label: "Opdrachtgever",
            children: replacementTransportPlan?.company?.fullName ?? "Algemeen",
          },
          {
            label: "Beschikbare vervangend vervoer opties",
            children:
              replacementTransportPlan?.options?.member
                .map((option) => option.option.title)
                .join(", ") || "Geen opties geselecteerd",
          },
        ];
        return <Descriptions items={items} />;
      })()}
    </Card>
  );
};
